/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Image from '@/components/image';
import AllIngredients from '@/components/product/all-ingredients';
import { ModalContext } from '@/context/modal';
//import { gsap } from 'gsap';
//import { useGSAP } from "@gsap/react";
//import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useRef, useContext } from 'react';
import { useLocale } from 'next-intl';

//Load Module
//gsap.registerPlugin(useGSAP);
//gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function PrimaryNotes({ product, ...props }){

	const ref = useRef();
	const locale = useLocale();
	const { Modal } = useContext(ModalContext);
/*
	//On Mount
	useGSAP(() => {

		//Skip if it hasn't loaded
		if( !ref.current ) return;

		//Prepare the MatchMedia
		let mm = gsap.matchMedia();

		//Set Variables
		const $section      = ref.current;
		const $image        = $section.querySelector('img');
		const $title        = $section.querySelectorAll('h2 *');
		const $description  = $section.querySelector('p');
		const $button       = $section.querySelector('.button');

		//
		mm.add('(min-width: 751px)', context => {

			//Create Timeline
			let timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					start:                  '-80% left',
					end:                    '50% left',
				},
			});

			//The Image Animation
			//timeline.fromTo( $image, { opacity:0, yPercent:10 },{ opacity:1, yPercent:0 });

			//Each title part
			$title.forEach(
				( $part , i ) => timeline.delay( ( i * 1 ) ).fromTo( $part, { opacity:0, yPercent:10 },{ opacity:1, yPercent:0 })
			);

			//Description & Button Last
			timeline.delay( 50 ).fromTo( [ $description, $button ], { opacity:0, yPercent:10 },{ opacity:1, yPercent:0 });

		});

	}, { scope: ref.current });
*/
	//Return
	return (
		<section id="ingredient-block" ref={ ref }>
			{ product.blocks.ingredients.image && (
				<Image src={ product.blocks.ingredients.image.src } alt="" width="365" height="285" />
			)}
			<div>
				<h2 dangerouslySetInnerHTML={{
					__html: product.blocks.ingredients.title?.[ locale ]
				}} />
				<p>{ product.blocks.ingredients.description?.[ locale ] }</p>
				<AllIngredients product={ product } />
			</div>
		</section>
	);

}